// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-family: Arial, sans-serif;
    background-color: #000;
    color: #fff;
}


.player-camera {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: black;
}

video {
    width: 50%;
    height: 100%;
    float: left;
}

#connectInfo {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fff;
    display: block;
    font-size: 2em;
}

.icon-grid div {
    border: 5px solid white;
    font-size: 10vw;
    width: 12vw;
    height: 12vw;
    line-height: 12vw;
    text-align: center;
    background: rgb(20, 181, 255);
    color: red;
    font-weight: bold;
    border-radius: 3vw;
}

.icon-grid {
	display: grid;
	grid-template-areas:
		". grid-top ."
		"grid-left grid-center grid-right"
		". grid-bottom .";
	justify-items: center;
	align-items: center;
}

.icon-grid div {
	opacity: 0.1;
}

.icon-grid div.active {
	opacity: 1;
}

.icon-grid div.grid-top {
	grid-area: grid-top;
}

.icon-grid div.grid-bottom {
	grid-area: grid-bottom;
}

.icon-grid div.grid-left {
	grid-area: grid-left;
}

.icon-grid div.grid-right {
	grid-area: grid-right;
}

.icon-grid div.grid-center {
	grid-area: grid-center;
}

.icon-grid:has(.active) div.grid-center {
    opacity: 1;
    /* animation: slide shake */
    animation: shake 300ms infinite;
}

@keyframes shake {
    /** Shake is actually slightly rotating the element */
    0% {
        transform: rotate(0deg);
    }

    25% {
        transform: rotate(5deg);
    }

    50% {
        transform: rotate(0deg);
    }

    75% {
        transform: rotate(-5deg);
    }

    100% {
        transform: rotate(0deg);
    }
}

/* 
Animate the grid so that each corner moves in the direction of the arrow. Ie: grid top moves to the top and back, grid-left moves to the left and back, etc. 
Animation should only go in one direction, not loop back and forth. 
*/
.icon-grid div.grid-top.active {
    animation: move-top 500ms infinite;
    animation-timing-function: ease-out;
}

.icon-grid div.grid-bottom.active {
    animation: move-bottom 500ms infinite;
    animation-timing-function: ease-out;
}

.icon-grid div.grid-left.active {
    animation: move-left 500ms infinite;
    animation-timing-function: ease-out;
}

.icon-grid div.grid-right.active {
    animation: move-right 500ms infinite;
    animation-timing-function: ease-out;
}

#move-grid.icon-grid div.grid-left.active {
    animation: move-left-and-rotate 500ms infinite;
}

#move-grid.icon-grid div.grid-right.active {
    animation: move-right-and-rotate 500ms infinite;
}

@keyframes move-top {
    0% {
        transform: translateY(0);
    }
    80% {
        transform: translateY(-3vmin);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes move-bottom {
    0% {
        transform: translateY(0);
    }
    80% {
        transform: translateY(3vmin);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes move-left {
    0% {
        transform: translateX(0);
    }
    80% {
        transform: translateX(-3vmin);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes move-left-and-rotate {
    0% {
        transform: translateX(0);
    }
    80% {
        transform: rotate(-30deg) ;
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes move-right {
    0% {
        transform: translateX(0);
    }
    80% {
        transform: translateX(3vmin);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes move-right-and-rotate {
    0% {
        transform: translateX(0);
    }
    80% {
        transform: rotate(30deg) ;
    }
    100% {
        transform: translateX(0);
    }
}

#move-grid {
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    color: #fff;
    z-index: 100;
}

#move-grid div {
    background: rgb(20, 181, 255);
}

#watch-grid {
    position: absolute;
    bottom: 2rem;
    right: 2rem;
    color: #fff;
    z-index: 100;
}

#watch-grid div {
    background: rgb(240, 252, 77);
}

.boot-form {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 5vmin;
    color: black
}

.boot-form button {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 10px 20px;
    margin: 10px 0;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

.boot-form button:hover {
    background-color: #0056b3;
}

.boot-form form {
    margin-top: 20px;
}

.boot-form input[type="number"] {
    width: calc(100% - 22px);
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;CACC,aAAa;CACb;;;mBAGkB;CAClB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,qDAAqD;IACrD;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;;;CAGC;AACD;IACI,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    font-family: Arial, sans-serif;\n    background-color: #000;\n    color: #fff;\n}\n\n\n.player-camera {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    background-color: black;\n}\n\nvideo {\n    width: 50%;\n    height: 100%;\n    float: left;\n}\n\n#connectInfo {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    color: #fff;\n    display: block;\n    font-size: 2em;\n}\n\n.icon-grid div {\n    border: 5px solid white;\n    font-size: 10vw;\n    width: 12vw;\n    height: 12vw;\n    line-height: 12vw;\n    text-align: center;\n    background: rgb(20, 181, 255);\n    color: red;\n    font-weight: bold;\n    border-radius: 3vw;\n}\n\n.icon-grid {\n\tdisplay: grid;\n\tgrid-template-areas:\n\t\t\". grid-top .\"\n\t\t\"grid-left grid-center grid-right\"\n\t\t\". grid-bottom .\";\n\tjustify-items: center;\n\talign-items: center;\n}\n\n.icon-grid div {\n\topacity: 0.1;\n}\n\n.icon-grid div.active {\n\topacity: 1;\n}\n\n.icon-grid div.grid-top {\n\tgrid-area: grid-top;\n}\n\n.icon-grid div.grid-bottom {\n\tgrid-area: grid-bottom;\n}\n\n.icon-grid div.grid-left {\n\tgrid-area: grid-left;\n}\n\n.icon-grid div.grid-right {\n\tgrid-area: grid-right;\n}\n\n.icon-grid div.grid-center {\n\tgrid-area: grid-center;\n}\n\n.icon-grid:has(.active) div.grid-center {\n    opacity: 1;\n    /* animation: slide shake */\n    animation: shake 300ms infinite;\n}\n\n@keyframes shake {\n    /** Shake is actually slightly rotating the element */\n    0% {\n        transform: rotate(0deg);\n    }\n\n    25% {\n        transform: rotate(5deg);\n    }\n\n    50% {\n        transform: rotate(0deg);\n    }\n\n    75% {\n        transform: rotate(-5deg);\n    }\n\n    100% {\n        transform: rotate(0deg);\n    }\n}\n\n/* \nAnimate the grid so that each corner moves in the direction of the arrow. Ie: grid top moves to the top and back, grid-left moves to the left and back, etc. \nAnimation should only go in one direction, not loop back and forth. \n*/\n.icon-grid div.grid-top.active {\n    animation: move-top 500ms infinite;\n    animation-timing-function: ease-out;\n}\n\n.icon-grid div.grid-bottom.active {\n    animation: move-bottom 500ms infinite;\n    animation-timing-function: ease-out;\n}\n\n.icon-grid div.grid-left.active {\n    animation: move-left 500ms infinite;\n    animation-timing-function: ease-out;\n}\n\n.icon-grid div.grid-right.active {\n    animation: move-right 500ms infinite;\n    animation-timing-function: ease-out;\n}\n\n#move-grid.icon-grid div.grid-left.active {\n    animation: move-left-and-rotate 500ms infinite;\n}\n\n#move-grid.icon-grid div.grid-right.active {\n    animation: move-right-and-rotate 500ms infinite;\n}\n\n@keyframes move-top {\n    0% {\n        transform: translateY(0);\n    }\n    80% {\n        transform: translateY(-3vmin);\n    }\n    100% {\n        transform: translateY(0);\n    }\n}\n\n@keyframes move-bottom {\n    0% {\n        transform: translateY(0);\n    }\n    80% {\n        transform: translateY(3vmin);\n    }\n    100% {\n        transform: translateY(0);\n    }\n}\n\n@keyframes move-left {\n    0% {\n        transform: translateX(0);\n    }\n    80% {\n        transform: translateX(-3vmin);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes move-left-and-rotate {\n    0% {\n        transform: translateX(0);\n    }\n    80% {\n        transform: rotate(-30deg) ;\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes move-right {\n    0% {\n        transform: translateX(0);\n    }\n    80% {\n        transform: translateX(3vmin);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes move-right-and-rotate {\n    0% {\n        transform: translateX(0);\n    }\n    80% {\n        transform: rotate(30deg) ;\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n#move-grid {\n    position: absolute;\n    bottom: 2rem;\n    left: 2rem;\n    color: #fff;\n    z-index: 100;\n}\n\n#move-grid div {\n    background: rgb(20, 181, 255);\n}\n\n#watch-grid {\n    position: absolute;\n    bottom: 2rem;\n    right: 2rem;\n    color: #fff;\n    z-index: 100;\n}\n\n#watch-grid div {\n    background: rgb(240, 252, 77);\n}\n\n.boot-form {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    max-width: 400px;\n    margin: 0 auto;\n    margin-top: 5vmin;\n    color: black\n}\n\n.boot-form button {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    margin: 10px 0;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.boot-form button:hover {\n    background-color: #0056b3;\n}\n\n.boot-form form {\n    margin-top: 20px;\n}\n\n.boot-form input[type=\"number\"] {\n    width: calc(100% - 22px);\n    padding: 10px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
